export const COMPANY = {
  name: 'CLÍNICA VETERINARIA LOS CUARTOS S.L.',
  commercialName: 'Clínica Veterinaria Los Cuartos',
  nif: 'B16732778',
  domain: 'clinicaveterinarialoscuartos.net',
  address: 'Avenida Sor Soledad Cobián 27-29, 38300 La Orotava (Santa Cruz de Tenerife), España',
  shortAddress: 'Av. Sor Soledad Cobian, 29, 38300 La Orotava, Santa Cruz de Tenerife',
  phone: '922 32 22 94',
  email: 'cvetloscuartos@gmail.com',
  web: 'https://clinicaveterinarialoscuartos.net/',
};

/** Coordenadas solo para centrar el mapa OpenStreetMap en la web */
export const MAP_POSITION = [28.39176, -16.517671];

/** Texto que Google Maps usa para buscar el negocio por nombre y dirección */
export const GOOGLE_MAPS_QUERY = `${COMPANY.commercialName}, ${COMPANY.shortAddress}`;

export const getGoogleMapsSearchUrl = () =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(GOOGLE_MAPS_QUERY)}`;

export const getGoogleMapsDirectionsUrl = () =>
  `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(GOOGLE_MAPS_QUERY)}`;
